import { render } from "preact";
import { configureWebCore } from "@tenergy/web-core";
import { AdminApp } from "./admin-app.js";
import { adminEnv } from "./env.js";
import "./styles.css";

/**
 * The entry point: configure the headless core once, start the mocked API when this build
 * asked for one, then mount.
 *
 * The mock is behind a dynamic import inside a flag branch, so a production build eliminates
 * the branch and none of msw is in the bundle.
 */
async function main(): Promise<void> {
  const env = adminEnv();
  configureWebCore({
    apiBaseUrl: env.apiBaseUrl,
    tronNetwork: env.tronNetwork,
    tronFullHost: env.tronFullHost,
    walletConnectProjectId: env.walletConnectProjectId,
  });

  if (env.mockApi) {
    try {
      const { startMockApi } = await import("./mocks/browser.js");
      await startMockApi();
    } catch (error) {
      // A mock that will not start must not leave a blank page: the panel still mounts and
      // every screen then shows its own failed-fetch state, which is at least diagnosable.
      console.error("the mocked API did not start", error);
    }
  }

  const root = document.getElementById("root");
  if (root === null) throw new Error("#root is missing from index.html");
  render(<AdminApp />, root);
}

void main();
